import { Component, Input } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from 'src/app/services/app/app.service';
import { DocumentService } from 'src/app/services/document/document.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { PaginationInstance } from 'ngx-pagination';
import { Filter } from '../../filter/filter.model';
import { CommonService } from 'src/app/services/common/common.service';
import { ViewSignedContractsComponent } from '../../documents/view-signed-contracts/view-signed-contracts.component';
import { ViewDocumentsComponent } from '../../documents/view-documents/view-documents.component';
import { MatDialog } from '@angular/material/dialog';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { ViewContractDocumentComponent } from '../../documents/view-contract-document/view-contract-document.component';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { ViewFolderComponent } from '../../documents/view-folder/view-folder.component';

@Component({
  selector: 'app-hr-docs',
  templateUrl: './hr-docs.component.html',
  styleUrls: ['./hr-docs.component.scss'],

})
export class HrDocsComponent {
  @Input() employeeId!: string | number;
  public currentTab: string = "manage_visa"


  public co_i;
  public contractArr: any[] = []
  public usefulDocArr: any[] = []
  public packArr: any[] = []
  public userArr: any[] = []
  public empList: any[] = []
  public empContractDoc: any[] = []
  public empPersonalDoc: any[] = []
  public empUsefullDoc: any[] = []
  public empCourseData: any;
  public packDocDetail: any;
  public isSpinnerLoading: boolean = false;
  public imageURL: string = GlobalService.imageURL;
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public searchInput: string = '';
  private previousInputValue: string = '';
  public baseUrl!: string;
  public count!: number;
  public isAdmin: boolean = false;
  public selectedEmployeeId!: string;
  public isFilterShow: boolean = false;
  public filterObj: Filter = {
    operand: "or",
    arr: []
  }
  public packId!: number;
  public companyId!: string;

  constructor(private recruiterService: RecruiterService, private docService: DocumentService, private dialog: MatDialog, private appService: AppService, private cookieService: CookieService, private commonService: CommonService) { }
  ngOnInit(): void {
    this.checkUserType()
  }

  checkUserType() {
    // if( this.cookieService.get('user_id') && window.location.href.includes('doc-dashboard') ){
    if (this.cookieService.get('user_id')) {
      // whenever admin user set the token of admin 
      this.appService.storeData('training-portal.admin-authToken', this.cookieService.get('user_id'));
      this.appService.storeSessionData('isAdmin', JSON.stringify(true));
      this.companyId = this.cookieService.get('company_id')
      this.isAdmin = true;
    }
    else {
      let obj = JSON.parse(this.appService.getData('training-portal.userInfo'))
      this.companyId = obj.company_id
    }
  }

  onCurrentTab(value: string) {
    this.currentTab = value

    if (value == 'con_documents') {
      this.contractDocList()
    }
    if (value == 'documents') {
      this.getEmpCourseWork(0, this.employeeId)
      this.getAllDocument()

    }
  }

  contractDocList() {
    this.isSpinnerLoading = true;
    let obj = {
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      sh: this.searchInput,
      op_nd: this.filterObj.operand,
      f_a: [],
      em_i: this.employeeId,
      co_i: this.companyId,
    }
    this.docService.contractDocumentList(obj).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false;
        if (success.status == 200) {
          this.baseUrl = success.base;
          this.contractArr = [];
          this.contractArr = success["msg"];
          this.count = success.count;
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    });
  }

  onViewDocument(item) {
    const dialogRef = this.dialog.open(ViewDocumentsComponent, {
      width: '50%', minWidth: '280px', height: 'auto', maxHeight: '90vh', maxWidth: "868px",
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire",
      autoFocus: false, data: item
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
        // this.usefulDocList()

      }
    });
  }
  onViewSignedContract(item) {
    let obj = {
      id: item.document_id
    }
    const dialogRef = this.dialog.open(ViewSignedContractsComponent, {
      width: '50%', minWidth: '280px', height: 'auto', maxHeight: '90vh', maxWidth: "868px",
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire",
      autoFocus: false, data: obj
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
        // this.usefulDocList()

      }
    });
  }
  onFile(baseUrl, document) {
    let URL = baseUrl + document;
    this.appService.downloadFile(URL, 'contract-document')
  }
  onFileDownload(data: string) {
    this.appService.downloadFile(data, 'useful-document')
  }
  onDeleteItem(id: string | number) {
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: 'contract_document', id: id }
    },));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        if (this.currentTab == "action_document") {

        }
        else {
          this.callAPI()
        }
        //  this.callAPI()
      }
    });
  }
  callApi(obj) {
    this.filterObj = obj
    this.callAPI()
  }
  callAPI() {
    if (this.currentTab == 'con_documents') {
      this.contractDocList()
    }
  }
  getPackList() {
    this.isSpinnerLoading = true;
    // if(this.companyId){}
    this.packArr = []
    //if no pack then delete all the user data & pack related data
    this.userArr = []
    this.packDocDetail = ''
    this.count = 0
    this.docService.getPackList(this.companyId).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false;
        if (success.status == 200 && success.msg.length > 0) {
          this.packArr = [];
          this.packArr = success.msg;
          if (this.packArr.length > 0) {
            this.packArr.map((item) => (item["selected"] = ""));
            this.packArr[0].selected = true;
            this.packId = this.packArr[0]["id"];
            this.getPackDocList(this.packId);
          }
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    });
  }
  onViewContractDoc(item) {
    const dialogRef = this.dialog.open(ViewContractDocumentComponent, {
      width: '60%', minWidth: '280px', height: '90%', maxHeight: '700px', maxWidth: '800px',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire",
      data: this.baseUrl + item.document

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
        // this.getPackDocList(this.packId)
      }
    });
  }
  getPackDocList(id) {
    let dataObj = {
      "pack_id": id,
      "r_p": this.config.itemsPerPage,
      "st": this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      sh: this.searchInput,
      f_a: this.filterObj.arr,
      op_nd: this.filterObj.operand,
      search: ''
    }
    this.userArr = []
    this.isSpinnerLoading = true;
    this.docService.getAllPackDoc(dataObj).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.previousInputValue = this.searchInput
          this.isSpinnerLoading = false;
          this.userArr = success.msg.u_d;
          this.packDocDetail = success.msg;
          this.count = success.msg.count;
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    });
  }

  onAddContract() {
    let data = {}
    this.docService.addContract(data).subscribe((result) => {
      if (result.status == 200) {
        var newWindow = window.open(result.data.url, '_blank', 'height=700,width=700');
      }
    })
  }

  getAllDocument() {
    let dataObj = {
      em_i: this.employeeId,
      co_i: this.companyId
    }
    this.recruiterService.getAllDocument(dataObj).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          // this.empDocList = success.msg;
          this.empContractDoc = success.msg.contract_doc
          this.empPersonalDoc = success.msg.personal_document
          this.empUsefullDoc = success.msg.useful_doc
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    });


  }

  onFileDownloadAll(data: string) {


    this.appService.downloadFile(data, 'useful-document')
  }

  onFileAll(baseUrl, document) {

    let URL = baseUrl + document;
    this.appService.downloadFile(URL, 'contract-document')
  }

  getEmpCourseWork(f_id, e_id) {
    this.isSpinnerLoading = true;
    this.docService.getEmpCourseWork(f_id, e_id).subscribe({
      next: (result: any) => {
        this.isSpinnerLoading = false;
        if (result.status == 200) {
          this.empCourseData = result.data.listing;
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    });
  }

  onViewFolder(id: string, e_id: string) {
    const dialogRef = this.dialog.open(ViewFolderComponent, {
      width: '60%', minWidth: '280px', height: 'auto', maxHeight: '90vh',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire",
      data: { folder_id: id, e_id: e_id }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
      }
    });
  }

  onDeleteCourseDocItem(id: string | number) {
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: 'course_document', id: id }
    },));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        this.getEmpCourseWork(0,this.employeeId)
        //  this.callAPI()
      }
    });
  }
}
